import { ProductsItem } from '@app-types/api/statics';
import { ShortListContext } from '@app-types/eligibility';

import { TECHNOLOGY } from '@constants/provider';

import { EligibilityOffer } from './eligibility-offer';
import { EligibilityResults } from './eligibility-results';
import { normalizeTechnology } from './technology';

export function splitShortListParams(param: string = ''): { rangeNgCommercialSeries: string; technology: string } {
    param = param.toLowerCase();
    const technosEligible = [
        TECHNOLOGY.FTTH.toLowerCase(),
        TECHNOLOGY.BOX_4G.toLocaleLowerCase(),
        TECHNOLOGY.BOX_5G.toLocaleLowerCase(),
    ];
    const technology = technosEligible.find((tech) => param.includes(tech))!;
    const rangeNgCommercialSeries = param.replace(`_${technology}`, '');

    return {
        rangeNgCommercialSeries,
        technology,
    };
}

export function getShortListName(
    rangeNgCommercialSeries: string,
    technology: TECHNOLOGY,
    staticsData: ProductsItem[],
): string {
    const foundItemName =
        staticsData.find((c) => {
            return (
                rangeNgCommercialSeries === `${c.range_ng}_${c.commercial_series}` &&
                c.techno.toUpperCase() === technology
            );
        })?.title ?? '';

    if (!foundItemName) {
        return (
            staticsData.find((c) => {
                return rangeNgCommercialSeries === c.range && c.techno.toUpperCase() === technology;
            })?.title ?? ''
        );
    }

    return foundItemName;
}

export function isEligibleToFocusOffer(shortList?: ShortListContext, results?: EligibilityResults): boolean {
    if (!shortList || !results) {
        return false;
    }

    const technology = normalizeTechnology(shortList.technology);

    const focusOffer = results.offers[technology]?.find((offer) =>
        offer.isSameRangeOrOldRange(shortList.rangeNgCommercialSeries),
    );

    return focusOffer !== undefined;
}

export function getShortListOffer(offers: EligibilityOffer[], shortList?: ShortListContext) {
    if (!shortList) return undefined;
    return offers.find(
        (offer) => offer.isSameRangeOrOldRange(shortList.rangeNgCommercialSeries) && !offer.isHiddenInFocus,
    );
}
